import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { propOr } from "ramda";
import { v4 as uuidv4 } from "uuid";

const linkStyle = { color: "#000" };

// Falls back through the tenant name fields so a group always shows something
// recognisable, whichever fields that tenant actually fills in.
export const groupDisplayName = (customer) =>
  propOr("", "trading_name", customer) ||
  propOr("", "owner_name", customer) ||
  propOr("", "site_name", customer) ||
  propOr("", "name", customer) ||
  propOr("", "address", customer) ||
  `#${propOr("", "id", customer)}`;

const GroupItem = ({ group, onOpen }) => {
  const [expanded, setExpanded] = useState(false);
  const children = propOr([], "children", group);
  const hasUnits = children.length > 0;

  const toggleExpanded = useCallback(() => {
    setExpanded((current) => !current);
  }, []);

  const openDetail = useCallback(() => onOpen && onOpen(group), [onOpen, group]);

  const onRowClick = useCallback(
    (event) => {
      // Let the actions dropdown handle its own clicks.
      if (event.target.closest(".dropdown")) return;
      openDetail();
    },
    [openDetail]
  );

  return (
    <>
      <tr onClick={onRowClick} style={{ cursor: "pointer" }}>
        <td className="customer-name">
          <Link to={`/customer-group/${group.id}`} style={linkStyle}>
            {groupDisplayName(group)}
          </Link>
        </td>
        <td className="customer-info">
          <span>{propOr("", "address", group)}</span>
        </td>
        <td className="customer-info">
          <span>{propOr("", "meter_id", group)}</span>
        </td>
        <td className="customer-info">
          <span>{propOr(0, "units_count", group)}</span>
        </td>
        <td className="customer-actions">
          <Dropdown className="text-center">
            <Dropdown.Toggle
              variant=""
              className="btn-text dropdown-toggle border-0 bg-transparent p-1"
              style={{ fontSize: "16px" }}
            >
              <i className="fas fa-ellipsis-v"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu align="right">
              <Dropdown.Item onClick={toggleExpanded} disabled={!hasUnits}>
                <i
                  className={`fas fa-chevron-${expanded ? "up" : "down"} mr-2`}
                ></i>
                {expanded ? "Collapse units" : "Expand sub-meters"}
              </Dropdown.Item>
              <Dropdown.Item onClick={openDetail}>
                <i className="fas fa-external-link-alt mr-2"></i>
                View detail
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
      </tr>

      {expanded &&
        children.map((child) => (
          <tr key={uuidv4()} className="group-unit-row">
            <td className="customer-name" style={{ paddingLeft: "32px" }}>
              <i className="fas fa-level-up-alt fa-rotate-90 mr-2 text-muted" />
              <Link to={`/customer/${child.id}/usage`} style={linkStyle}>
                {groupDisplayName(child)}
              </Link>
            </td>
            <td className="customer-info">
              <span>{propOr("", "address", child)}</span>
            </td>
            <td className="customer-info">
              <span>{propOr("", "meter_id", child)}</span>
            </td>
            <td />
            <td />
          </tr>
        ))}
    </>
  );
};

export default GroupItem;
